import React from "react";

const Hair = () => {
  return <div>Hair</div>;
};

export default Hair;
